import { memo } from "react"
import type { Photo } from "./types"
import styles from "./GalleryWindow.module.css"

type Props = {
  photos: Photo[]
  onPhotoClick: (index: number, photo: Photo) => void
}

const PhotoCell = memo(({ photo, index, onPhotoClick }: { photo: Photo; index: number; onPhotoClick: (index: number, photo: Photo) => void }) => (
  <button
    className={styles.cell}
    onClick={() => onPhotoClick(index, photo)}
    aria-label={photo.label || ""}
  >
    <img 
      src={photo.src} 
      alt={photo.label || ""} 
      className={styles.img} 
      loading="lazy" 
      decoding="async" 
      draggable={false}
    />
  </button>
))

PhotoCell.displayName = 'PhotoCell'

export default function PhotosGrid({ 
  photos, 
  onPhotoClick
}: Props) {
  return (
    <div className={styles.grid}>
      {photos.map((photo, index) => (
        <PhotoCell 
          key={photo.id} 
          photo={photo} 
          index={index} 
          onPhotoClick={onPhotoClick}
        />
      ))}
    </div>
  )
}
